import { Loader } from '@mantine/core';

export default function LoadingScreen() {
    return (
        <div className="relative w-full h-dvh flex flex-col justify-center items-center bg-page">
            <Loader type="bars" size={'lg'} />
        </div>
    );
}
